import { Col, Container, Row } from "react-bootstrap";
import HOME_QUERY from "../../queries/home";
import Query from "../Query";
import { Link } from "react-router-dom";

const LeistungenBlock = () => {
  return (
    <Query query={HOME_QUERY} id={null}>
      {({ data: { home } }) => {
        return (
          <section className="layout layout__color_primary">
            <Container fluid>
              <Row className="justify-content-between mb-5">
                <Col md={6} lg={6} xxl={7} className="mb-5 mb-xl-0">
                  <h2 data-aos="fade-up">
                    {home.data.attributes.Services.title}
                  </h2>
                </Col>
                <Col xxl={4}>
                  <h4 className="h3 tt-normal" data-aos="fade-up">
                    {home.data.attributes.Services.description}
                  </h4>
                </Col>
                <Col xxl={1}></Col>
              </Row>
              <div className="layout_chapters">
                {home.data.attributes.Services.Categories.map((item, index) => {
                  return (
                    <Link
                      to={`/fuehrerscheine/${item.name}`}
                      rel="noopener noreferrer"
                      key={item.id}
                      className="layout_chapters_item"
                      data-aos="fade-up"
                    >
                      <Row>
                        <Col
                          xs={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? 12
                              : 3
                          }
                          md={6}
                          xl={5}
                          xxl={6}
                          className={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? "order-1 order-md-0 text-end text-md-start text-xxl-end mt-4 mt-md-0"
                              : "text-xxl-end"
                          }
                        >
                          <h3 className="text-xxl-end layout_chapters_title layout_chapters_title_new">
                            {item.name}
                          </h3>
                        </Col>
                        <Col
                          xs={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? 12
                              : 9
                          }
                          md={6}
                          lg={5}
                          xl={4}
                          xxl={5}
                          className="offset-xl-1 layout_chapters_text"
                        >
                          <p
                            className="layout_text mb-3 mb-xxl-0"
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                          <button
                            className={
                              index ===
                              home.data.attributes.Services.Categories.length -
                                1
                                ? "d-none"
                                : "btn btn__border btn__border_primary d-xxl-none"
                            }
                          >
                            Weiterlesen{" "}
                            <img
                              alt="team"
                              className="ms-2"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACBUlEQVRIie2VT2sTURRHzx2TunMhghIpuJrUlTEJLgQVUcT4JxZbXFhdCHbsQgW/gAaLn0A3qSIKCpGK4CAogkI3oqmTbASTQRC6CBUkWASlWue5ic50oXkzw3TV3+pxePeeuW8eM7CaFYpo7bLKL4G9AChV55fs57b9NY7Y0NolrPPXsoMU96hU9GrjiY1R4HOAlOk4V+OI12jtetv6wvah1whjfo3somi6OO675MQAjfYcRXMBpNQjAnKIvPmchttJTgzguHUK2QxQ6JE0IofZlq3RbIe6bBEuyKbzwEwAZEgxzYXS2mTFU1M/QY0CHwN0J4vpapg24Y76Txz3G/mtM4g6DQz0aI6i2cVx68mJARqteYrZFnCCvx8iOUDenKXhfkhODOC031Mw0yC7e8RAKJEbekSz3f1faayvDwCZwmXA9oGsx1D3+5XFF0dMfHGnOQmUfaC6eDLWr0zv7/SvjB8dQWQ60GcJ8Q5SffKiX2n0iceHc4jcZfnDX9KRQtSJz5Y3YjALDPqd5A7Vx2d0W4Sf2LLSGDxYJoVXDPyYCNMmwlHP3wD2BMAcHse5/nQxObF17CJgBch3hBFu2Z9C9SHMOz53ZB/KeAakekShOMlNuxZWCroTTwxvQRm1gBQU16JK9cXKewhsCBCbzfkrUaX6YlgIrN+wxCkqFS+OeDUrlt8cKoJU3Wc7+AAAAABJRU5ErkJggg=="
                            ></img>
                          </button>
                        </Col>
                      </Row>
                    </Link>
                  );
                })}
              </div>
            </Container>
          </section>
        );
      }}
    </Query>
  );
};

export default LeistungenBlock;
